import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { useSelectedTheme } from '../../../Hooks';

// Styles
import useStyles from './styles';

function CPP_MarketingAllComponentSkeleton() {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  const Divider = () => <Skeleton variant='rect' height={1} width={'100%'} />;

  return (
    <React.Fragment>
      <Box className={styles.marketingSkeletonPageWrapper}>
        <Box className={styles.propertyLabelSkeletonSection}>
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
        </Box>

        <Box className={styles.priceAndSizeSkeletonSection}>
          <Box className={styles.priceField}>
            <Skeleton variant='rect' height={20} width={280} />
            <Box
              style={{
                width: '512px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <Skeleton variant='rect' height={24} width={'100%'} />
              <Box style={{ display: 'flex', gap: '8px' }}>
                <Skeleton variant='rect' height={32} width={120} />
                <Skeleton variant='rect' height={32} width={120} />
              </Box>
            </Box>
          </Box>
          <Divider />
          <Box className={styles.sizeField}>
            <Skeleton variant='rect' height={20} width={280} />
            <Box
              style={{
                width: '512px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <Skeleton variant='rect' height={24} width={'100%'} />
              <Box style={{ display: 'flex', gap: '8px' }}>
                <Skeleton variant='rect' height={32} width={120} />
                <Skeleton variant='rect' height={32} width={120} />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className={styles.marketingTitleSkeletonSection}>
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
          <Divider />
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
        </Box>

        <Box className={styles.marketingUSPSkeletonSection}>
          {[1, 2, 3, 4].map((item) => (
            <React.Fragment key={item}>
              <Box className={styles.fieldWrapper}>
                <Skeleton variant='rect' height={20} width={280} />
                <Skeleton variant='rect' height={44} width={512} />
              </Box>
              {item !== 4 && <Divider />}
            </React.Fragment>
          ))}
        </Box>

        <Box className={styles.marketingDescriptionSkeletonSection}>
          <Box className={styles.descriptionFieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={160} width={512} />
          </Box>
          <Divider />
          <Box className={styles.descriptionFieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={160} width={512} />
          </Box>
        </Box>

        <Box className={styles.additionalFieldsSkeletonSection}>
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
          <Divider />
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
        </Box>

        <Box className={styles.marketingTitleSkeletonSection}>
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
          <Divider />
          <Box className={styles.fieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={44} width={512} />
          </Box>
        </Box>

        <Box className={styles.marketingDescriptionSkeletonSection}>
          <Box className={styles.descriptionFieldWrapper}>
            <Skeleton variant='rect' height={20} width={280} />
            <Skeleton variant='rect' height={160} width={512} />
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default CPP_MarketingAllComponentSkeleton;
